import { Dropdown } from 'primereact/dropdown';
import { useLanguageContext } from '../../contexts/LanguageContext';

function LanguageSelection() {
  const { setLanguageContext, availableLanguages, currentLanguage } = useLanguageContext();

  const valueTemplate = (option) => {
    if (!option) return null;
    return <span className={`fi fi-${option.code} `}></span>;
  };

  const itemTemplate = (option) => {
    if (!option) return null;
    return (
      <div className="flex items-center gap-x-2">
        <span className={`fi fi-${option.code} `}></span>
        <span>{option.label}</span>
      </div>
    );
  };

  return (
    <Dropdown
      onChange={(e) => setLanguageContext(e.value.key)}
      value={currentLanguage}
      options={availableLanguages}
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="language-selector-dropdown rounded-full px-2 border-0 hover:bg-slate-100"
    />
  );
}

export default LanguageSelection;
